import styled, { css } from 'styled-components';

import theme from '@/styles/theme';
import { BottomSheet } from 'doctornow-design-system';

interface Props<T> {
  open: boolean;
  title: string;
  list: T[];
  onClick: (item: T) => void;
  getItemName: (item: T) => string;
  isSelected?: (item: T) => boolean;
  onClose: () => void;
}

const CardInstallmentBottomSheet = <T,>(props: Props<T>) => {
  const { open, title, list, onClick, getItemName, isSelected, onClose } = props;
  return (
    <BottomSheet type='single' title={title} open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Wrapper>
        <FilterList>
          {list.map((item) => (
            <Filter
              key={`filter-${getItemName(item)}`}
              onClick={() => onClick(item)}
              isSelected={isSelected && isSelected(item)}
            >
              <p>{getItemName(item)}</p>
            </Filter>
          ))}
        </FilterList>
      </Wrapper>
    </BottomSheet>
  );
};

export default CardInstallmentBottomSheet;

const Wrapper = styled.div`
  padding: 0 0 32px;
`;

const FilterList = styled.ul`
  max-height: 500px;
  overflow-y: scroll;
`;

const Filter = styled.li<{ isSelected?: boolean }>`
  ${({ theme }) => css`
    & > p {
      ${theme.typography.UI16M}
      color: ${theme.color.gray800};
    }
  `}
  height: 56px;
  padding: 16px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  ${({ isSelected }) =>
    `
      ${isSelected ? `background-color: ${theme.color.gray30}` : `background-color: ${theme.color.white}`}; :
      `}
`;
